'use client';

import { getIdFromText } from 'utils/formatters';

interface TabItemProps extends React.HTMLProps<HTMLButtonElement> {
  isActive: boolean;
  id: string;
}

const TabItem = ({ children, onClick, isActive, id }: TabItemProps) => {
  const formattedId = getIdFromText(id);
  return (
    <button
      id={`tab-${formattedId}`}
      className={`tab font-sans font-semibold text-center px-6 py-2.5 rounded-md content-primary w-full md:w-auto ${
        isActive ? 'bg-action-primary' : ''
      }`}
      onClick={onClick}>
      {children}
    </button>
  );
};

export default TabItem;
